export default {
  Read: function(action, self, onsuccess, onfailed, order, filter, page) {
    return {
        data : {    
          filter  : filter,
          order   : order,
          page    : page,
          AuthorizationToken : self.props.UserReducer.token,
        },
        self : self,
        action: action,
        onsuccess : self.onReadSuccess,
        onfailed : self.onReadFailed,
    }
  }
}


// WEBPACK FOOTER //
// ./src/App/booking/helper/request.props.js